import React from "react"
import { Outlet, Route, Routes } from "react-router-dom"
import { CompanyRegister } from "./pages/company/CompanyRegister"
import { CompanyInfo } from "./pages/company/CompanyInfo"
import { CompanyUpdate } from "./pages/company/CompanyUpdate"
import { CompanyList } from "./pages/company"
import { CompanyEdit } from "./pages/company/CompanyEdit"
import { EmployeeRegister } from "./pages/employee/EmployeeRegister"
import { EmployeeDetail } from "./pages/employee/EmployeeDetail"
import { EmployeeEdit } from "./pages/employee/EmployeeEdit"
import { EmployeeList } from "./pages/employee"
import { EmployeeImport } from "./pages/employee/EmployeeImport"
import { OpenAPI } from "./openapi"
import { MyPageDetail } from "./pages/mypage/MyPageDetail"
import { MyPageEdit } from "./pages/mypage/MyPageEdit"
import { TagList } from "./pages/tag"
import { TagRegister } from "./pages/tag/TagRegister"
import { TagEdit } from "./pages/tag/TagEdit"
import { PasswordUpdate } from "./pages/password"

import MainLayout from "./components/layout/MainLayout"
import { Callback } from "./pages/callback"
import EmployeeSignup from "./pages/invitation/EmployeeSignup"
import LinkLineAccount from "./pages/invitation/LinkLineAccount"

export function Body() {
  OpenAPI.BASE = process.env.REACT_APP_API_URL

  return (
    <Routes>
      <Route
        element={
          <MainLayout>
            <Outlet />
          </MainLayout>
        }
      >
        <Route path="/" element={<MyPageDetail />} />
        <Route path="/company" element={<CompanyList />} />
        <Route path="/company/register" element={<CompanyRegister />} />
        <Route path="/company/edit/:companyId" element={<CompanyEdit />} />
        <Route path="/company/:companyId/info" element={<CompanyInfo />} />
        <Route path="/company/:companyId/update" element={<CompanyUpdate />} />
        <Route path="/company/:companyId/employee/register" element={<EmployeeRegister />} />
        <Route path="/company/:companyId/employee/detail/:id" element={<EmployeeDetail />} />
        <Route path="/company/:companyId/employee/edit/:id" element={<EmployeeEdit />} />
        <Route path="/company/:companyId/employee" element={<EmployeeList />} />
        <Route path="/company/:companyId/employee/import" element={<EmployeeImport />} />
        <Route path="/mypage" element={<MyPageDetail />} />
        <Route path="/mypage/edit" element={<MyPageEdit />} />
        <Route path="/company/:companyId/tag" element={<TagList />} />
        <Route path="/company/:companyId/tag/register" element={<TagRegister />} />
        <Route path="/company/:companyId/tag/edit/:id" element={<TagEdit />} />
        <Route path="/password" element={<PasswordUpdate />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/line/signup" element={<EmployeeSignup />} />
        <Route path="/line/account_link" element={<LinkLineAccount />} />
      </Route>
    </Routes>
  )
}
